/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".page-planning[_ngcontent-%COMP%]{display:flex;height:100%}.page-planning[_ngcontent-%COMP%]   app-planning-side[_ngcontent-%COMP%]{background-color:#fff;height:100%;position:absolute;left:74px;top:0;width:303px;border-left:1px solid #dadada}.page-planning[_ngcontent-%COMP%]   app-map[_ngcontent-%COMP%]{width:calc(100% - 378px);height:100%;position:fixed;right:0;top:0}"];
export { styles as styles };
